import { success, failure, request } from 'app/actions';
import * as actions from './reportsActions';
import * as helpers from './reportHelpers';

const initialRanking = {
  content: [],
  totalrecords: 0,
  totalpages: 0,
  recordsperpage: 10,
  page: 0,
};

const initialState = {
  groups: [],
  groupsFilters: [],
  contracts: [],
  generalReport: {},
  ranking: initialRanking,
  disciplines: [],
  years: [],

  studentsAnswersQuestionReport: [],
  generalComparativeReport: {},
  disciplineComparativeReport: [],
  questionsDetailsComparativeReport: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case success(actions.GET_GROUPS):
      return {
        ...state,
        groups: action.payload.content,
        contracts: helpers.getContracts(action.payload.content),
        years: helpers.getYears(action.payload.content),
      };
    case success(actions.GET_GENERAL_PAINEL_FILTERS):
      return {
        ...state,
        groupsFilters: action.payload.content,
        contracts: helpers.getContracts(action.payload.content),
        years: helpers.getYears(action.payload.content),
      };
    case failure(actions.GET_ESGRADE_GENERAL):
      return {
        ...state,
        generalReport: initialState.generalReport,
      };
    case success(actions.GET_ESGRADE_GENERAL):
      return {
        ...state,
        generalReport: action.payload.content,
      };
    case failure(actions.GET_ESGRADE_BY_RANKING_STUDENT):
      return {
        ...state,
        ranking: initialState.ranking,
      };
    case success(actions.GET_ESGRADE_BY_RANKING_STUDENT): {
      const prevContent = state.ranking.content || [];
      const newContent = action.payload.content || [];
      const shouldAppend =
        prevContent.length > 0 &&
        newContent.length > 0 &&
        newContent[0].position > prevContent[prevContent.length - 1].position;

      if (!shouldAppend) {
        return {
          ...state,
          ranking: action.payload,
        };
      }
      return {
        ...state,
        ranking: {
          ...action.payload,
          content: [...prevContent, ...newContent],
        },
      };
    }
    case failure(actions.GET_ESGRADE_BY_DISCIPLINE):
      return {
        ...state,
        disciplines: initialState.disciplines,
      };
    case success(actions.GET_ESGRADE_BY_DISCIPLINE):
      return {
        ...state,
        disciplines: action.payload.content,
      };
    case success(actions.GENERATE_BATCH_PDF):
      return {
        ...state,
        id: action.payload.id,
      };

    case request(actions.GET_STUDENTS_ANSWERS_QUESTION_REPORT):
      return {
        ...state,
        studentsAnswersQuestionReport: initialState.studentsAnswersQuestionReport,
      };
    case success(actions.GET_STUDENTS_ANSWERS_QUESTION_REPORT):
      return { ...state, studentsAnswersQuestionReport: action.payload.content };
    case request(actions.GET_ES_GRADE_COMPARATIVE_BY_DISCIPLINE):
      return {
        ...state,
        disciplineComparativeReport: initialState.disciplineComparativeReport,
      };
    case success(actions.GET_ES_GRADE_COMPARATIVE_BY_DISCIPLINE):
      return { ...state, disciplineComparativeReport: action.payload.content };
    case request(actions.GET_ES_GRADE_COMPARATIVE_GENERAL):
      return {
        ...state,
        generalComparativeReport: initialState.generalComparativeReport,
        generalReport: initialState.generalReport,
        ranking: initialState.ranking,
      };
    case success(actions.GET_ES_GRADE_COMPARATIVE_GENERAL):
      return { ...state, generalComparativeReport: action.payload.content };
    case request(actions.GET_ES_QUESTIONS_DETAILS_BY_COMPARATIVE):
      return {
        ...state,
        questionsDetailsComparativeReport: initialState.questionsDetailsComparativeReport,
      };
    case success(actions.GET_ES_QUESTIONS_DETAILS_BY_COMPARATIVE):
      return { ...state, questionsDetailsComparativeReport: action.payload.content };
    default:
      return state;
  }
};

export default reducer;
